import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = ({ token, setToken, role }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    setToken(null);
    navigate('/login');
  };

  return (
    <nav style={styles.navbar}>
      <div style={styles.navContainer}>
        <div style={styles.leftSection}>
          <Link to="/" style={styles.navBrand}>
            <i className="fas fa-school" style={{ marginRight: '8px' }}></i>
            THOGOTO T.T.C Leave System
          </Link>
        </div>
        <div style={styles.rightSection}>
          <Link to="/home" style={styles.navLink}>
            <i className="fas fa-home" style={styles.icon}></i> Home
          </Link>

          {token ? (
            <>
              {/* Always show Apply Leave link when logged in */}
              <Link to="/apply-leave" style={styles.navLink}>
                <i className="fas fa-edit" style={styles.icon}></i> Apply Leave
              </Link>

              {/* Conditional links for professors/admins */}
              {(role && (role.toLowerCase() === 'professor' || role.toLowerCase() === 'admin')) && (
                <Link
                  to={role.toLowerCase() === 'professor' ? '/professor-dashboard' : '/admin-dashboard'}
                  style={styles.navLink}
                >
                  <i className="fas fa-tasks" style={styles.icon}></i> Review Leaves
                </Link>
              )}

              <Link to="/leaves" style={styles.navLink}>
                <i className="fas fa-folder-open" style={styles.icon}></i> Leaves
              </Link>
              <button onClick={handleLogout} style={styles.logoutButton}>
                <i className="fas fa-sign-out-alt" style={styles.icon}></i> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" style={styles.navLink}>
                <i className="fas fa-sign-in-alt" style={styles.icon}></i> Login
              </Link>
              <Link to="/register" style={styles.navLink}>
                <i className="fas fa-user-plus" style={styles.icon}></i> Register
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};


const styles = {
  navbar: {
    backgroundColor: '#A51C30',
    padding: '1rem 2rem',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    fontFamily: "'Georgia', serif",
  },
  navContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
  },
  navBrand: {
    color: '#fff',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    textDecoration: 'none',
    letterSpacing: '0.5px',
    display: 'flex',
    alignItems: 'center',
  },
  navLink: {
    color: '#fff',
    margin: '0 1.2rem',
    textDecoration: 'none',
    fontSize: '1.1rem',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: '6px',
  },
  logoutButton: {
    backgroundColor: 'transparent',
    color: '#fff',
    border: '1px solid #fff',
    padding: '0.5rem 1rem',
    cursor: 'pointer',
    borderRadius: '4px',
    fontSize: '1rem',
    marginLeft: '1rem',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
  },
};

export default Navbar;
